import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { ScreenQuery } from './ScreenQuery.graphql.js';

export function preloadScreen(spaceKey) {
	return query({
		query: ScreenQuery,
		variables: {
			spaceKey,
		},
	});
}
